var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppleLogo = function SvgAppleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#fff",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.723 13.154c.832 0 1.875-.55 2.496-1.282.562-.663.972-1.59.972-2.517 0-.126-.011-.252-.035-.355-.925.034-2.039.606-2.707 1.373-.527.584-1.008 1.5-1.008 2.438 0 .137.024.274.036.32.058.011.152.023.246.023ZM16.793 27c1.137 0 1.64-.744 3.059-.744 1.441 0 1.757.721 3.023.721 1.242 0 2.074-1.121 2.86-2.22.878-1.259 1.242-2.494 1.265-2.552-.082-.022-2.46-.972-2.46-3.639 0-2.311 1.874-3.352 1.98-3.432-1.243-1.74-3.13-1.786-3.645-1.786-1.395 0-2.531.824-3.246.824-.774 0-1.793-.778-3-.778-2.297 0-4.629 1.854-4.629 5.356 0 2.174.867 4.474 1.934 5.961.914 1.26 1.71 2.289 2.859 2.289Z"
  })));
};
export default SvgAppleLogo;